import React from 'react';

import { rankingsLTMUrl } from 'buyside/util/urlHelper';

import PodiumIcon from 'buyside/svgs/podium.svg';

import styles from './rankingsWidgetStyles.scss';

const ActivityFeedRankingsWidget: React.FunctionComponent<{ children?: React.ReactNode }> = ({
  children
}): React.ReactElement => {
  return (
    <div className={styles.container} data-heap-segment="rankings-widget">
      <a
        data-heap="rankings-widget-heading"
        href={rankingsLTMUrl()}
        className={styles.rankingsWidgetHeader}
      >
        <PodiumIcon className={styles.calendarIcon} />
        <p>Rankings - Last Twelve Months</p>
      </a>
      <div className={styles.content}>
        <div className={styles.subheader}>Most Recent Idea</div>
        <ol>{children}</ol>
        <a data-heap="rankings-widget-see-more" className={styles.moreLink} href={rankingsLTMUrl()}>
          See More...
        </a>
      </div>
    </div>
  );
};

export default ActivityFeedRankingsWidget;
